export default "__VITE_ASSET__yfW2n6BY__"